module.exports = __webpack_public_path__ + "static/img/mouth_02.46d65c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/mouths/thumbnail/mouth_02.png
// module id = WoVs
// module chunks = 0